export class SoilLayer {
    /**
     * @param zoneFieldCapacity The zone's field capacity (a volumetric fraction), for a layer that has no
     *   capacity of its own: what "full" means when the depth profile shows a reading as a share of it.
     */
    constructor(json: Partial<SoilLayer>, zoneFieldCapacity: number | undefined = undefined) {
        this.sandPercentage = json.sandPercentage;
        this.clayPercentage = json.clayPercentage;
        this.depth = json.depth;
        this.recommendedCapacity = json.recommendedCapacity;
        this.userCapacity = json.userCapacity;
        this.lastMoistureReading = json.lastMoistureReading;
        this.lastMoistureReadingDate = new Date(json.lastMoistureReadingDate);
        this.zoneFieldCapacity = zoneFieldCapacity;
    }
    public getJSON(): Partial<SoilLayer> {
        const keysToCopy = [
            "sandPercentage",
            "clayPercentage",
            "depth",
            "recommendedCapacity",
            "userCapacity",
            "lastMoistureReading",
            "lastMoistureReadingDate",
        ];
        const newObj = {};
        keysToCopy.forEach((k) => {
            newObj[k] = this[k];
        });
        return newObj;
    }
    public get sand(): number {
        return this.sandPercentage;
    }

    public get silt(): number {
        return this.siltPercentage;
    }

    public get clay(): number {
        return this.clayPercentage;
    }

    /** The water content this layer counts as full: its own capacity, else the zone's field capacity. */
    public get soilCapacity(): number {
        return this.userCapacity || this.zoneFieldCapacity || this.recommendedCapacity || 1.0;
    }

    public zoneFieldCapacity: number | undefined;
    public sandPercentage!: number;

    public clayPercentage!: number;

    get siltPercentage() {
        return 1 - this.sandPercentage - this.clayPercentage;
    }
    /**
     * in meters
     * @type {number}
     */
    public depth!: number;

    get depthInches(): number {
        return this.depth * 39.3701;
    }

    getPrettyDepth(inches = undefined): string {
        if (inches === false) {
            return Math.round(this.depth / 100).toString() + "cm";
        }
        if (inches) {
            return Math.round(this.depth / 39.3701).toString() + '"';
        }
        return Math.round(this.depth / 39.3701).toString() + '"';
    }

    public recommendedCapacity?: number;

    public userCapacity?: number;

    public lastMoistureReading?: number;

    public lastMoistureReadingDate?: Date;
}
